import locationsModal from './locations-modal'

export const CardForecastThreeDays = {
  load: async function (idlocale, todayUrl, city15DaysUrl) {
    let status = (await navigator.permissions.query({ name: "geolocation" })).state;
    const $link = $('#card-forecast-three-days-location');

    if (status === "prompt" || status === "denied") {
      $("#location-icon-allow").css("display", "none");
      $("#location-icon-deny").css("display", "flex");

      $link.attr('role', 'button');
      $link.removeAttr('href');
      $link.attr('data-id', 'Card_ThreeDaysForecast_Link_UseLocation');
      $link.off('click.ct3d').on('click.ct3d', function (e) {
        e.preventDefault();
        window.dataLayer = window.dataLayer || [];
        locationsModal.open();
        window.dataLayer.push({ event: 'click_button', id: 'Card_ThreeDaysForecast_Link_UseLocation' });
      });
    } else {
      $("#location-icon-allow").css("display", "flex");
      $("#location-icon-deny").css("display", "none");

      $link.attr('role', 'link');
      $link.attr('href', todayUrl);
      $link.attr('data-id', 'Card_ThreeDaysForecast_Link_Location');
      $link.off('click.ct3d');
    }


    const forecastData = await fetch(
      `/json/myclimatempo/user/forecastFiveDays?idlocale=${idlocale}`
    );

    if (!forecastData.ok)
      throw new Error(
        `Erro na resposta do servidor: ${forecastData.statusText}`
      );

    const forecastResult = await forecastData.json();
    $(".card-forecast-three-days-location").html(forecastResult.infoCity.city);

    $(".card-forecast-three-days-column-icon").each(function (index, element) {
      $(element).attr(
        "src",
        `/dist/images/v2/svg/${forecastResult.data.getFiveDaysForecast[index].textIcon.icon.day}.svg`
      );

      $(element).attr(
        "data-src",
        `/dist/images/v2/svg/${forecastResult.data.getFiveDaysForecast[index].textIcon.icon.day}.svg`
      );

      $(element).attr(
        "alt",
        `${forecastResult.data.getFiveDaysForecast[index].textIcon.text.pt}`
      );
    });

    $(".card-forecast-three-days-column-temp-min").each(function (
      index,
      element
    ) {
      $(element).html(
        `${forecastResult.data.getFiveDaysForecast[index].temperature.min}°`
      );
    });

    $(".card-forecast-three-days-column-temp-max").each(function (
      index,
      element
    ) {
      $(element).html(
        `${forecastResult.data.getFiveDaysForecast[index].temperature.max}°`
      );
    });

    $(".card-forecast-three-days-column-description").each(function (
      index,
      element
    ) {
      $(element).html(
        forecastResult.data.getFiveDaysForecast[index].textIcon.text
          .reducedPhrasePt
      );
    });

    $(".button-see-full-forecast-card-forecast-three-days").attr(
      "href",
      city15DaysUrl
    );
  },
};
